import React from "react"
import { sentryInit } from "./components/Sentry/SentryInit/SentryInit"
import { loadEnvVars } from "./utils/loadEnvVars"

import { createRoot } from "react-dom/client"
import { App } from "./App"

const isProd = loadEnvVars().env === "prod"
const env = loadEnvVars().env

!!env && sentryInit(!isProd)

const container = document.getElementById("root")
if (!container) throw new Error("Root container missing")
const root = createRoot(container)
root.render(<App />)
